"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const timer_1 = require("./timer");
const event_manager_1 = require("./event-manager");
class TimeSpentTimer {
    constructor(config = {}) {
        this.idleTimer = new timer_1.Timer(1000, this.userIdle.bind(this));
        this.timeTimer = new timer_1.Timer(config.interval, config.onTick);
        this.idleThreshold = config.idleThreshold || 5000;
        this.idleCallback = config.onIdle;
        this.eventManager = new event_manager_1.EventManager();
    }
    get TimeSpent() {
        return this.timeTimer.Elapsed;
    }
    init() {
        this.bindEvents();
        this.start(this.timeTimer);
        this.start(this.idleTimer);
    }
    bindEvents() {
        //start events
        this.eventManager.onFocus(this.userReturned.bind(this));
        //reset events
        this.eventManager.onMouseMove(this.userActive.bind(this));
        this.eventManager.onKeyUp(this.userActive.bind(this));
        this.eventManager.onTouchStart(this.userActive.bind(this));
        this.eventManager.onScroll(this.userActive.bind(this));
        //pause events
        this.eventManager.onBlur(this.userLeft.bind(this));
        //Minimize 
        this.eventManager.onVisibilityChange(isHidden => {
            isHidden ? this.userLeft() : this.userReturned();
        });
    }
    userLeft() {
        //Pauze both timers
        this.pause(this.timeTimer);
        this.pause(this.idleTimer);
        //Reset the idle timer
        this.reset(this.idleTimer);
    }
    userReturned() {
        //Resume both timers
        this.start(this.timeTimer);
        this.start(this.idleTimer);
    }
    userActive() {
        //Resume the timer
        this.start(this.timeTimer);
        //Reset and resume the idle timer
        this.reset(this.idleTimer);
        this.start(this.idleTimer);
    }
    userIdle() {
        if (this.idleTimer.Elapsed >= this.idleThreshold) {
            if (this.idleCallback)
                this.idleCallback();
            //Pause both timers
            this.pause(this.timeTimer);
            this.pause(this.idleTimer);
            //Reset the idle timer
            this.reset(this.idleTimer);
        }
    }
    start(timer) {
        timer.start();
    }
    pause(timer) {
        timer.pause();
    }
    reset(timer) {
        timer.reset();
    }
}
exports.default = TimeSpentTimer;
